
import {createModel} from "./model.js";
import {ø} from "../util/objects.js";
import {mapObject} from "../lib/underscore.js";


export function initialModalState() {
    return ø({
        show_settings: false,
        show_date_chooser: false,
    });
}

/**
 * @type {Model}
 */
export const modalStore = createModel(mapObject(initialModalState(), () => undefined));

export function restoreModalStore() {
    modalStore.save(initialModalState());
}
